import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './shared/layout/header/header.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { AuthService } from './auth/services/auth.service';
import { CookiesComponent } from './shared/components/cookies/cookies.component';
import { CookiePreferencesService } from './core/services/cookie-preferences.service';

@Component({
  selector: 'aig-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    CommonModule,
    CookiesComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'AIG - La Caixa: Ciberseguridad';

  cookies: boolean = false;

  constructor(
    private authService: AuthService,
    private cookiePreferencesService: CookiePreferencesService
  ) {

  }
  ngOnInit(): void {


    // Verificar si ya se han aceptado cookies antes de mostrar el modal
    this.cookies = !this.cookiePreferencesService.hasConsent();
  }

  authorize() {

    // Realiza la validación automáticamente al iniciar
    this.authService.requestAuthorization().subscribe({
      next: (response) => {

        // Lógica cuando la validación sea exitosa
        // Aquí puedes almacenar el token de acceso en el almacenamiento local si es necesario
        sessionStorage.setItem('authToken', response.access_token);
      },
      error: (err) => {
        console.error('No autorizado', err);
        // Mostrar mensaje de error o redirigir a otra página si es necesario
      },
    });
  }

  close(cookies: boolean): void {
    this.cookies = cookies;
    const body = document.body;
    body.style.overflow = 'auto';
  }
}
